var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWriting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.996 10.326a5.747 5.747 0 00-8.128 0L27.884 29.309a5.752 5.752 0 00-1.491 2.59l-2.492 9.39a1.184 1.184 0 001.428 1.453l9.498-2.35a5.752 5.752 0 002.684-1.515l11.812-11.814c.405-.109.72-.424.83-.828l3.258-3.259c.405-.11.72-.425.83-.83l2.224-2.224a5.754 5.754 0 000-8.128l-1.47-1.468zM48.9 24.139l-6.25-6.25 2.414-2.415 6.25 6.25-2.414 2.415zM35.836 37.204c-.434.435-.98.743-1.578.891l-7.558 1.87 1.98-7.46a3.39 3.39 0 01.877-1.523l11.42-11.42 6.251 6.251-11.392 11.391zM54.791 18.25l-1.802 1.802-6.25-6.25 1.801-1.803a3.381 3.381 0 014.782 0l1.468 1.47a3.385 3.385 0 010 4.78zM3.078 20.246h28.378a1.183 1.183 0 100-2.366H3.078a1.183 1.183 0 100 2.366zM3.078 30.303h17.035a1.183 1.183 0 000-2.367H3.078a1.183 1.183 0 100 2.367zM3.078 40.36h17.035a1.183 1.183 0 100-2.367H3.078a1.183 1.183 0 100 2.366zM35.954 48.05H3.078a1.183 1.183 0 100 2.367h32.876a1.183 1.183 0 100-2.367z",
    fill: "#F2F2F2"
  })));
}

export default SvgWriting;